import { render, staticRenderFns } from "./DetalharUsoUsuarioDialog.vue?vue&type=template&id=78354636&scoped=true"
import script from "./DetalharUsoUsuarioDialog.vue?vue&type=script&lang=js"
export * from "./DetalharUsoUsuarioDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalharUsoUsuarioDialog.vue?vue&type=style&index=0&id=78354636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78354636",
  null
  
)

export default component.exports